/**
 * Textarea — multiline text input. Same styling vocabulary as Input.
 */

import { forwardRef } from 'react'

const TONES = {
  default: 'bg-surface text-ink-primary border border-border placeholder:text-ink-muted hover:border-border-strong focus:border-brand focus:ring-brand/30',
  glass:   'bg-white/85 text-ink-primary border border-white/60 placeholder:text-ink-muted backdrop-blur-sm focus:border-brand focus:ring-brand/30 shadow-token-sm',
}

const Textarea = forwardRef(function Textarea(
  {
    invalid = false,
    tone = 'default',
    className = '',
    rows = 4,
    ...rest
  },
  ref
) {
  const toneCls = TONES[tone] || TONES.default
  const errorCls = invalid ? 'border-danger focus:border-danger focus:ring-danger/30' : ''
  return (
    <textarea
      ref={ref}
      rows={rows}
      className={`
        w-full px-3 py-2 text-sm rounded-lg transition-colors resize-y
        focus:outline-none focus:ring-2
        ${toneCls} ${errorCls} ${className}
      `}
      aria-invalid={invalid || undefined}
      {...rest}
    />
  )
})

export default Textarea
